module.exports = __webpack_public_path__ + "media/images/logo_nomargin-d39474e26fdaff424e5ccef6e917f037.jpeg";